import React, { useState } from 'react';
import routes from '../../../../../Routes/routes';
import { useNavigate } from 'react-router-dom';
/**
 *
 * @Author: Susana García Rodríguez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const VehicleCommons = () => {
    const navigate = useNavigate();
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));

    /**
     * Navigates back to the corresponding vehicle list
     * based on contractor or supplier context.
     */
    const handleOnBack = () => {
        const redirectRoute =
            contractorId !== null
                ? routes.vehicleContractor.search
                : supplierId !== null
                  ? routes.vehicleSupplier.list
                  : routes.vehicleFleet.list;

        navigate(redirectRoute);
    };

    return { handleOnBack };
};

export default VehicleCommons;
